import React, { Component } from "react";
import { Container, Row, Col, Accordion, Card } from "react-bootstrap";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import Layout from "../components/layout";

import {Animated} from "react-animated-css";

import ipOwnership from "../../static/images/products/ipOwnership.svg";
import toolsHeaderImage from "../../static/images/products/toolsHeaderImage.png";

import licensing from "../../static/images/products/licensing.svg";
import control from "../../static/images/products/control.svg";
// import integration from "../../static/images/products/integration.svg";

import DataScienceProducts from "../components/dataScienceProducts";
import DataScienceProductsMobile from "../components/dataScienceProductsMobile";

import DataEngineeringProducts from "../components/dataEngineeringProducts";
import DataEngineeringProductsMobile from "../components/dataEngineeringProductsMobile";

import DesignProducts from "../components/designProducts";
import DesignProductsMobile from "../components/designProductsMobile";

import DevOpsProducts from "../components/devOpsProducts";
import DevOpsProductsMobile from "../components/devOpsProductsMobile";

import DevelopmentProducts from "../components/developmentProducts";
import DevelopmentProductsMobile from "../components/developmentProductsMobile";

import SecurityProducts from "../components/securityProducts";
import SecurityProductsMobile from "../components/securityProductsMobile";

import QualityAssuranceProducts from "../components/qualityAssuranceProducts";
import QualityAssuranceProductsMobile from "../components/qualityAssuranceProductsMobile";

import SupportAndMaintenanceProducts from "../components/supportAndMaintenanceProducts";
import SupportAndMaintenanceProductsMobile from "../components/supportAndMaintenancceProductsMobile";


import '../styles/style.scss';

// import { getVisiblePercentage } from "../utilities/elementUtilities";

import { assignActiveElementNew, visibilityObject, changeSlideInClass } from "../utilities/elementUtilities";

class Tools extends Component {
  constructor(props) {
    super(props);

    this.handleAccordionClick = this.handleAccordionClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    this.handleScroll();
  }

  handleScroll = () => {

    // var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    // if (width > 700) {
    //   var news_heading = document.getElementById('implement-the-products');

    //   let percentage = getVisiblePercentage(news_heading);

    //   /*
    //     based on value of percentage change style of dots
    //   */

    //   var navigationDots = document.querySelectorAll("a.dot-link");
    //   // console.log(navigationDots);
    //   for (var i = 0, max = navigationDots.length; i < max; i++) {
    //     if (percentage > 5) {
    //       navigationDots[i].classList.add("news");
    //     } else {
    //       navigationDots[i].className = navigationDots[i].className.replace(/\bnews\b/g, "");
    //     }
    //   }

    // }


    // var sectionList = [
    //   document.getElementById('open-source'),
    //   document.getElementById('data-science'),
    //   document.getElementById('data-engineering'),
    //   document.getElementById('design'),
    //   document.getElementById('devops'),
    //   document.getElementById('development'),
    //   document.getElementById('security'),
    //   document.getElementById('quality-assurance'),
    //   document.getElementById('support-and-maintenance'),
    //   document.getElementById('mobile-products-group'),
    // ];
    // assignActiveElement(sectionList);

    var sectionList = [
      visibilityObject(document.getElementById('open-source')),
      visibilityObject(document.getElementById('tools-advantage')),
      visibilityObject(document.getElementById('data-science')),
      visibilityObject(document.getElementById('data-engineering')),
      visibilityObject(document.getElementById('design')),
      visibilityObject(document.getElementById('devops')),
      visibilityObject(document.getElementById('development')),
      visibilityObject(document.getElementById('security')),
      visibilityObject(document.getElementById('quality-assurance')),
      visibilityObject(document.getElementById('support-and-maintenance')),
      visibilityObject(document.getElementById('mobile-products-group')),
    ];
    assignActiveElementNew(sectionList);

    changeSlideInClass();
  }

  handleAccordionClick = (e) => {

    var mobileProductsGroup = document.getElementById('mobile-products-group');

    var cardDivArray = mobileProductsGroup.querySelectorAll('.card');

    // console.log(cardDivArray);

    var targetData = e.target.getAttribute("data");

    for (var i = 0; i < cardDivArray.length; i++) {
      var cardDiv = cardDivArray[i];
      var cardHeaderDiv = cardDiv.querySelectorAll('.card-header')[0];
      var collapseDiv = cardDiv.querySelectorAll('.collapse')[0];
      var collapseDivClasses = collapseDiv.className.split(' ');
      // console.log(collapseDivClasses);
      var cardHeaderDivData = cardHeaderDiv.getAttribute("data");

      // console.log(targetData + " " + cardHeaderDivData);
      var cardHeaderDivClasses = cardHeaderDiv.className.split(' ');
      if (targetData === cardHeaderDivData) {
        if (collapseDivClasses.includes("show")) {
          // console.log("collapse cardHeaderDiv");
          if (cardHeaderDivClasses.indexOf("collapsed") === -1) {
            cardHeaderDiv.className += " collapsed";
          }
        } else {
          // console.log("expand cardHeaderDiv");
          cardHeaderDiv.classList.remove("collapsed");
        }
      } else {
        if (cardHeaderDivClasses.indexOf("collapsed") === -1) {
          cardHeaderDiv.className += " collapsed";
        }
      } 
    }

  }

  render() {
    return(  
      <Layout headerBrand={"BLD.AI"} footerMargin={false} layoutClassName="products-page">
        <div className="side-dots-nav">
          <ul className="nav-items">
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="implement-the-products"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="open-source"
                  spy={true}
                  smooth={true}
                  offset={-340}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="tools-advantage"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item mobile-products">
              <Link
                  activeClass="active"
                  to="shoulders-of-giants"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="data-science"
                  spy={true}
                  smooth={true}
                  offset={-200}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="data-engineering"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="design"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="devops"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="development"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="security"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="quality-assurance"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item desktop-products">
              <Link
                  activeClass="active"
                  to="support-and-maintenance"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            {/* <li className="nav-item mobile-products">
              <Link
                  activeClass="active"
                  to="mobile-products-group"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li> */}
          </ul>
        </div>
        <Container className="full-container">
          <section id="implement-the-products" className="section products-heading products-heading-mobile full first">
            {/* <p className="heading">We use well documented, secure, free and open source software to build products that you own.</p> */}
            <Row>
              <Col sm="12" lg="6" className="products-heading-img-holder">
                <img src={toolsHeaderImage} alt="check" className="" />
              </Col>
              <Col sm="12" lg="6" className="products-heading-caption-column">
                <Row className="products-heading-caption">
                  <Col sm="12" className="products-heading-header">
                    <p className="header-right">We use well documented, secure, free and open source software to build products that you own.</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </section>
        </Container>
        <Container className="full-container">
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="open-source" className="section page-second-section quarter">
              <Row>
                <Col xs={12} className="page-second-section-header">
                  <p className="heading">Organizations that decide to <span className="emphasized-word-span">buy</span> software are essentially conceding a significant portion of their identity, control and ability to grow as an organization. When you <span className="emphasized-word-span">build</span> software, for which you own all the IP, you are creating differentiated customer experience and shareholder value for decades to come.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="tools-advantage" className="section products-section height-70">
              <div>
                <p className="headingApproach">Benefits of our approach</p>
                <Row>
                  <Col className="tools-approach-item" xs={12} lg={4}>
                    <div className="team-makeup-box">
                      <div className="team-makeup-img">
                        <img src={ipOwnership} alt="IP Ownership" className="product-img-check" />
                      </div>
                      <div className="team-makeup-box-title-section">
                        <div className="team-makeup-box-title">
                          <h4 className="caps white px18">IP ownership</h4>
                        </div>
                      </div>
                      <div className="team-makeup-box-description">
                        All IP we create together is your property, because we use high quality, well-documented, free and open source software.
                      </div>
                    </div>
                  </Col>
                  <Col className="tools-approach-item" xs={12} lg={4}>
                    <div className="team-makeup-box">
                      <div className="team-makeup-img">
                        <img src={licensing} alt="No Licensing Fees" className="product-img-check" />
                      </div>
                      <div className="team-makeup-box-title-section">
                        <div className="team-makeup-box-title">
                          <h4 className="caps white px18">No licensing fees</h4>
                        </div>
                      </div>
                      <div className="team-makeup-box-description">
                        Because you own the IP, there are no licensing fees that reduce your bottom line; freeing up resources to build bespoke software.
                      </div>
                    </div>
                  </Col>
                  <Col className="tools-approach-item" xs={12} lg={4}>
                    <div className="team-makeup-box">
                      <div className="team-makeup-img">
                        <img src={control} alt="Feature Control" className="product-img-check" />
                      </div>
                      <div className="team-makeup-box-title-section">
                        <div className="team-makeup-box-title">
                          <h4 className="caps white px18">Full feature control</h4>
                        </div>
                      </div>
                      <div className="team-makeup-box-description">
                        Software as a service that you buy does not address unique business needs. We build only those features that will have a material impact on your business.
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>
          </Animated>
        </Container>
        <div className="desktop-products">
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="data-science" className="section products-section full tools">
              <Container className="full-container">
                <p className="shoulders-of-giants desktop">
                  We stand on the shoulders of giants to build AI products for you. Those giants include companies like Google, Amazon and Microsoft, who build and support well documented free and open source software. Below is a subset of such tools and frameworks.
                </p>
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading data-science">
                        <section id="data-science-tools">
                          <h3>Data Science</h3>
                        </section>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <DataScienceProducts />
              </Container>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="data-engineering" className="section products-section full data-engineering tools">
              <Container className="full-container">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading">
                        <h3>Data Engineering</h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <DataEngineeringProducts />
              </Container>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="design" className="section products-section full tools">
              <Container className="full-container">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading">
                        <h3>Design</h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <DesignProducts />
              </Container>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="devops" className="section products-section full tools">
              <Container className="full-container">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading">
                        <h3>Devops</h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <DevOpsProducts />
              </Container>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="development" className="section products-section full tools">
              <Container className="full-container">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading">
                        <h3>Development</h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <DevelopmentProducts />
              </Container>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="security" className="section products-section full tools">
              <Container className="full-container">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading">
                        <h3>Security</h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <SecurityProducts />
              </Container>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="quality-assurance" className="section products-section full tools2">
              <Container className="full-container">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading">
                        <h3>Quality Assurance</h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <QualityAssuranceProducts />
              </Container>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <section id="support-and-maintenance" className="section products-section full tools2">
              <Container className="full-container">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col xs={12} className="technology-header heading">
                        <h3>Support and Maintenance</h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <SupportAndMaintenanceProducts />
              </Container>
            </section>
          </Animated>
        </div>
        <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
          <div className="mobile-products mobile-product-links sectionDiv" id="mobile-products-group">
            <Container className="full-container">
              <p id="shoulders-of-giants" className="shoulders-of-giants">
                We stand on the shoulders of giants to build AI products for you. Those giants include companies like Google, Amazon and Microsoft, who build and support well documented free and open source software. Below is a subset of such tools and frameworks.
              </p>
            </Container>
            <Container className="full-container">
              <Accordion>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="0" onClick={this.handleAccordionClick}
                    className="collapsed" data="prod1">
                    DATA SCIENCE
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <DataScienceProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="1" onClick={this.handleAccordionClick}
                  className="collapsed" data="prod2">
                    DATA ENGINEERING
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <DataEngineeringProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="2" onClick={this.handleAccordionClick}
                  className="collapsed" data="prod3">
                    DESIGN
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <DesignProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="3" onClick={this.handleAccordionClick}
                  className="collapsed" data="prod4">
                    DEVOPS
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body>
                      <DevOpsProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="4" onClick={this.handleAccordionClick}
                  className="collapsed" data="prod5">
                    DEVELOPMENT
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="4">
                    <Card.Body>
                      <DevelopmentProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="5" onClick={this.handleAccordionClick}
                  className="collapsed" data="prod6">
                    SECURITY
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="5">
                    <Card.Body>
                      <SecurityProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="6" onClick={this.handleAccordionClick}
                  className="collapsed" data="prod7">
                    QUALITY ASSURANCE
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="6">
                    <Card.Body>
                      <QualityAssuranceProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle as={Card.Header} variant="link" eventKey="7" onClick={this.handleAccordionClick}
                  className="collapsed" data="prod8">
                    SUPPORT AND MAINTENANCE
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="7">
                    <Card.Body>
                      <SupportAndMaintenanceProductsMobile />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Container>
          </div>
        </Animated>
      </Layout>
    );
  }
}

export default (Tools);
